// extracted by mini-css-extract-plugin
export default {"container":"_6RH0E5z01GPCGKJ6R9VsWS","heading":"_6FbA7btB7DCtw3hFoRvsmD","buttonContainer":"_4krcNwPDKKFtprx4EtBtvy","extraAction":"_18X52r0rqo3221PdvKfFje"};